export default "__VITE_ASSET__CeP_VRNr__"